import api from "../../axios";

export const deleteLogo = async (iUserId) => {
  const aResponse = await api.delete(`/users/${iUserId}/logo`);
  return aResponse.data;
};
